import { render, staticRenderFns } from "./spells.vue?vue&type=template&id=8ab1912c&scoped=true&"
import script from "./spells.vue?vue&type=script&lang=js&"
export * from "./spells.vue?vue&type=script&lang=js&"
import style0 from "./spells.vue?vue&type=style&index=0&id=8ab1912c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab1912c",
  null
  
)

export default component.exports